import { StyleSheet } from 'aphrodite/no-important';
import { children, media } from 'util/style-helpers';

interface ToolTipStyle {
  top: string;
  left: string;
  bottom: string;
  right: string;
}

export const style: any = ({ top, left, bottom, right }: ToolTipStyle) => {
  return StyleSheet.create({
    container: {
      display: 'none',

      [media.tablet]: {
        display: 'block',
        position: 'absolute',
        top,
        left,
        bottom,
        right,
        zIndex: 5,
      },

      [media.desktop]: {
        display: 'none',
      },
    },
    arrow: {
      position: 'absolute',
      top: '-17px',
      zIndex: -1,
      width: '100%',

      [children('> svg')]: {
        display: 'flex',
        position: 'absolute',
        transform: 'translateX(-50%)',
        left: '50%',
        margin: '0 auto',
      },
    },
    btn: {
      width: '95px',
      fontSize: '14px',
    },
  });
};
